import { render, staticRenderFns } from "./productContent.vue?vue&type=template&id=97b60864&"
import script from "./productContent.vue?vue&type=script&lang=js&"
export * from "./productContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports